<template>
  <section id="section__credits" class="view-container">
    <WholesalerFinderDialog ref="whosalerFinder" />
    <div class="credits__contents" :class="{ empty: isWaitingTime || isEmpty || isLoading }">
      <v-row no-gutters>
        <v-col cols="12">
          <p class="font--m-4 mb-0">{{ pickedDate | dateKorean }} 주문목록</p>
        </v-col>
      </v-row>

      <template v-if="isLoading === true">
        <v-row no-gutters class="height-100" align="center">
          <v-col cols="12">
            <CreditDisplay />
          </v-col>
        </v-row>
      </template>

      <template v-else>
        <v-row v-if="serviceAvailable" no-gutters class="mt-2">
          <v-col cols="12">
            <OverlayProductsFileUploadButton>
              <template slot-scope="{ openDialog }">
                <BasicButton
                  color="pink"
                  height="33px"
                  @click="openDialog()"
                  id="btn__S6khEKUzw0qRUS1Om6Uuww=="
                >
                  사진 또는 엑셀 업로드하기
                </BasicButton>
              </template>
            </OverlayProductsFileUploadButton>
          </v-col>
        </v-row>

        <template v-if="showDisplay">
          <v-row no-gutters class="height-100" align="center">
            <v-col cols="12" class="text-center">
              <CreditDisplay :key="`display-${showDisplay}`" :display="showDisplay" />
              <template v-if="showDisplay === 'closed'">
                <div class="my-4">
                  <FileBox v-if="hasFiles" :key="pickedDate" :date="pickedDate" />
                </div>
                <BasicButton
                  id="btn__A/b72CfhrEiCfzwDScsBUQ=="
                  height="40px"
                  class="font--m-6"
                  :loading="cancelCreditLoading"
                  :disabled="cancelCreditLoading"
                  @click="cancelCredit"
                >
                  신청목록 수정하기
                </BasicButton>
              </template>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row no-gutters class="mt-4">
            <v-col v-for="mall in malls" :key="mall" cols="12">
              <MallTag :providerCode="mallSet[mall].provider" />
              <ProductCard
                v-for="item in mallSet[mall].items"
                :key="item.uuid"
                :product="item"
                :listId="listKey"
                @emitOpenWhosalerFinder="openWhosalerFinder"
                @emitRemoveProduct="removeItem"
              />
              <v-divider class="my-5"></v-divider>
            </v-col>

            <v-col cols="12" v-if="additions.length > 0">
              <p class="font--m-4 mb-2">[ 추가 입력 ]</p>
              <ProductCard
                v-for="add in additions"
                :key="add.uuid"
                :product="add"
                :listId="listKey"
                isAddition
                @emitOpenWhosalerFinder="openWhosalerFinder"
                @emitRemoveProduct="removeAdditionalItem"
              />
            </v-col>
          </v-row>
        </template>

        <v-row v-if="serviceAvailable" no-gutters class="mb-5">
          <v-col cols="12">
            <BasicButton color="black" @click="addProduct()" id="btn__jadONLvnfUatcRMvBTR5mg==">
              <v-icon color="white" class="add-icon">add_circle_outline</v-icon>
              추가 입력
            </BasicButton>
          </v-col>
        </v-row>
      </template>

      <v-row v-show="showSubmitBtn" class="position--relative" no-gutters>
        <v-col cols="12">
          <OverlayProductsConfirmButton>
            <template slot-scope="{ openDialog }">
              <div class="btn__submit-credit">
                <BasicButton
                  id="btn__Mob1zqi6kk6dOKetV86qOQ=="
                  height="100px"
                  :disabled="submitBtnIsDisabled"
                  :loading="saveLoading"
                  @click="submitCredit(openDialog)"
                >
                  <div>
                    <p class="color--white mb-4">
                      {{
                        isServiceAvailable ? '신청 마감까지:' : '계약 완료 이후 신청이 가능합니다'
                      }}
                      <CreditDeadlineTimer
                        :key="deadline ? deadline.toISOString() : 'none-deadline'"
                        :endTime="deadline"
                        :showTimeViewer="serviceAvailable === true"
                        @emitIsWaitingTime="(v) => (isWaitingTime = v)"
                      >
                        <template v-slot:default="{ timer }">
                          <span class="color--white">
                            {{ timer }}
                          </span>
                        </template>
                      </CreditDeadlineTimer>
                    </p>

                    <p class="font--m-6 font-weight-bold mb-2">
                      {{ validAmount | commaFormat }} 원
                    </p>
                    <p class="color--white font--m-6 mb-0">사입비 신청하기</p>
                  </div>
                </BasicButton>
              </div>
            </template>
          </OverlayProductsConfirmButton>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import ProductCard from '@/components/product/ProductCard.vue'
import WholesalerFinderDialog from '@/components/popups/WholesalerFinderDialog.vue'
import OverlayProductsConfirmButton from '@/components/overlay/button/OverlayProductsConfirmButton.vue'
import OverlayProductsFileUploadButton from '@/components/overlay/button/OverlayProductsFileUploadButton.vue'
import CreditDeadlineTimer from '@/components/timer/CreditDeadlineTimer.vue'
import MallTag from '@/components/mall/MallTag.vue'
import CreditDisplay from '@/components/display/CreditDisplay.vue'
import FileBox from '@/components/product/FileBox.vue'

export default {
  components: {
    ProductCard,
    WholesalerFinderDialog,
    OverlayProductsConfirmButton,
    OverlayProductsFileUploadButton,
    CreditDeadlineTimer,
    MallTag,
    CreditDisplay,
    FileBox,
  },
  data() {
    return {
      rawData: null,
      isWaitingTime: false,
      getLoading: false,
      saveLoading: false,
      pickedDate: null,
      originCredit: null,
      mallSet: {},
      additions: [],
      cancelCreditLoading: false,
    }
  },
  computed: {
    ...mapGetters('contract', ['isServiceAvailable']),
    ...mapGetters('product', ['getStatus']),
    isLoading() {
      return this.getLoading
    },
    malls() {
      return Object.keys(this.mallSet)
    },
    isEmpty() {
      return this.malls.length < 1 && this.additions.length < 1
    },
    hasFiles() {
      return this.rawData === 'CLOSED_WITH_FILES'
    },
    creditStatus() {
      let status = null
      if (typeof this.rawData === 'string') {
        status = this.rawData
      } else {
        if (this.isWaitingTime) {
          status = 'IS_WAITING'
        } else if (this.isEmpty) {
          status = 'NO_DATA'
        } else {
          status = null
        }
      }

      if (status === null) {
        return null
      }

      return this.getStatus?.[status]
    },
    showDisplay() {
      return this.creditStatus?.display
    },
    serviceAvailable() {
      if (this.isServiceAvailable !== true) {
        return false
      }
      return this.isWaitingTime === false && this.showDisplay !== 'closed'
    },
    listKey() {
      return this.originCredit?.uuid || null
    },
    deadline() {
      if (this.originCredit?.canBeRequestedBy) {
        return new Date(this.originCredit?.canBeRequestedBy)
      } else {
        return null
      }
    },
    validList() {
      let validCredits = []
      for (const mall of this.malls) {
        const valids = this.mallSet[mall].items.filter((item) => item.isValid() === true)
        validCredits = [...validCredits, ...valids]
      }

      const validAdds = this.additions.filter((add) => add.isValid() === true)
      const result = [...validCredits, ...validAdds]
      return result
    },
    validAmount() {
      let result = 0
      this.validList.forEach((v) => (result += v.getTotalAmount()))
      return result
    },
    showSubmitBtn() {
      return this.isEmpty === false && this.isLoading === false && this.isWaitingTime === false
    },
    submitBtnIsDisabled() {
      if (this.serviceAvailable !== true) {
        return true
      }
      return this.showSubmitBtn === false || this.saveLoading === true || this.validAmount < 1
    },
  },
  watch: {
    pickedDate(v) {
      this.getCredits(v)
    },
    isWaitingTime: {
      async handler(v) {
        if (v === false) {
          this.pickedDate = await this.getNowProductDate()
        }
      },
    },
  },
  async created() {
    const footer = document.querySelector('footer')
    const submitBtn = document.querySelector('.btn__submit-credit')
    const height = submitBtn?.offsetHeight || 100

    footer.style.paddingBottom = height + 20 + 'px'

    this.pickedDate = await this.getNowProductDate()
  },
  methods: {
    ...mapActions('product', [
      'getNowProductDate',
      'getCreditsDetailObj',
      'setDefaultValue',
      'addCredits',
      'removeProductsDetail',
      'getProductFiles',
      'getConfirmedCredits',
      'deleteProductFile',
      'cancelCredits',
    ]),
    dateSave(date) {
      this.$refs.dialog.save(date)
    },
    openWhosalerFinder(product) {
      this.$refs.whosalerFinder.switchDialog(product)
    },
    async getCredits(date) {
      if (this.isWaitingTime) {
        return
      }

      this.getLoading = true
      const result = await this.getCreditsDetailObj({ date })
      this.rawData = result

      if (result?.obj?.ADDITION) {
        this.additions = [...result.obj.ADDITION.items]
        delete result.obj.ADDITION
      }
      this.originCredit = result?.origin
      this.mallSet = result?.obj || {}

      this.getLoading = false
    },
    removeItem(product) {
      const mallId = product.mall.uuid
      const idx = this.mallSet[mallId].items.findIndex((item) => item.uuid === product.uuid)
      if (idx > -1) {
        this.mallSet[mallId].items.splice(idx, 1)
      }
    },
    removeAdditionalItem(product) {
      const idx = this.additions.findIndex((addi) => addi.uuid === product.uuid)
      if (idx > -1) {
        this.additions.splice(idx, 1)
      }
    },
    async addProduct() {
      if (this.listKey === null) {
        await this.addCredits({
          date: this.pickedDate,
          itemSet: [],
        })

        await this.getCredits()
      }
      const add = await this.setDefaultValue({})
      this.additions.push(add)
    },
    async submitCredit(openDialog) {
      try {
        openDialog(this.originCredit?.uuid)
      } catch (e) {
        this.$swal.basic.error('사입 주문목록 저장중 에러가 발생했습니다. 다시 시도해주세요.')
      }
    },
    async cancelCredit() {
      let text = '현재 사입금 신청내역을 삭제 후 다시 신청 목록을 작성하시겠습니까?'
      if (this.hasFiles) {
        text += '<br />(업로드된 파일은 삭제됩니다.)'
      }
      const confirm = await this.$swal.basic.confirm({ html: text })

      if (confirm.isConfirmed !== true) {
        return
      }

      try {
        this.cancelCreditLoading = true
        // 여기에 취소된 API
        if (this.hasFiles) {
          const files = await this.getProductFiles({ date: this.pickedDate })
          for (let index = 0; index < files.length; index++) {
            const file = files[index]
            await this.deleteProductFile(file)
          }
        } else {
          const confirmed = await this.getConfirmedCredits({ date: this.pickedDate })
          const listKey = confirmed?.origin.uuid
          await this.cancelCredits(listKey)
        }
        await this.getCredits(this.pickedDate)
      } finally {
        this.cancelCreditLoading = false
      }
    },
  },
}
</script>
<style lang="scss" scoped>
#section__credits {
  padding-top: 1rem;

  > .credits__contents {
    width: 100%;
    height: 100%;

    &.empty {
      display: flex;
      flex-direction: column;
    }
  }
}

.tools {
  display: flex;

  button {
    flex: 0 0 100px;

    &:not(:last-child) {
      margin-right: 10px;
    }
  }
}

.p-card {
  margin-bottom: 12px;
}

.btn__submit-credit {
  position: fixed;
  bottom: 5px;

  max-width: inherit;
  width: calc(100% - 30px);

  z-index: 100;

  @media screen and (min-width: $standard-max-width) {
    max-width: 500px;
  }
}
</style>
